var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4023 37.742C61.7 37.742 66.8045 32.6375 66.8045 26.3399C66.8045 20.0457 61.7 14.9377 55.4023 14.9377",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6465 50.1333C62.5278 50.2613 64.3953 50.531 66.2386 50.9391C68.7943 51.4475 71.8722 52.4953 72.9651 54.7882C73.6636 56.258 73.6636 57.9699 72.9651 59.4397C71.8757 61.7325 68.7943 62.7804 66.2386 63.3061",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1702 52.5884C45.9314 52.5884 56.8321 54.5216 56.8321 62.244C56.8321 69.97 46.0006 71.9689 33.1702 71.9689C20.4089 71.9689 9.51172 70.0391 9.51172 62.3132C9.51172 54.5873 20.3398 52.5884 33.1702 52.5884Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1691 41.5649C24.7516 41.5649 18.0078 34.8177 18.0078 26.4001C18.0078 17.986 24.7516 11.2388 33.1691 11.2388C41.5867 11.2388 48.3339 17.986 48.3339 26.4001C48.3339 34.8177 41.5867 41.5649 33.1691 41.5649Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoUser);
export default __webpack_public_path__ + "static/media/TwoUser.eab7c9ae.svg";
export { ForwardRef as ReactComponent };